
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/[userId]",
      function () {
        return require("private-next-pages/user/[userId].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/[userId]"])
      });
    }
  